import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Layout from '../views/layout.vue'
import Home from '../views/home/Home.vue'
import Product from '../views/product/Product.vue'
import Law from '../views/product/Law.vue'
import IndustryNews from '../views/product/IndustryNews.vue'
import Language from '../views/product/Language.vue'
import MedicalData from '../views/product/MedicalData.vue'
import MedicalRegister from '../views/product/MedicalRegister.vue'
import About from '../views/about/About.vue'
import Contact from '../views/contact/Contact.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'layout',
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
        path: '/product',
        name: 'product',
        component: Product
      },
      {
        path: '/law',
        name: 'law',
        component: Law
      },
      {
        path: '/language',
        name: 'language',
        component: Language
      },
      {
        path: '/industryNews',
        name: 'industryNews',
        component: IndustryNews
      },
      {
        path: '/medicalData',
        name: 'medicalData',
        component: MedicalData
      },
      {
        path: '/medicalRegister',
        name: 'medicalRegister',
        component: MedicalRegister
      },
      {
        path: '/about',
        name: 'about',
        component: About
      },
      {
        path: '/contact',
        name: 'contact',
        component: Contact
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to, from, next) => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})

export default router
